module.exports = __webpack_public_path__ + "img/jellybean_enclave.0d4a3b78.png";